import Vue from 'vue'
import router from '@/router/index'

/**
 * StoreManager - 店家資訊管理器
 *
 * 用途：
 * - 提供當前店家的 storeId、storeName、qrCodeHash
 * - 在路由與 Vuex 資料更新時同步變動
 * - qrCodeHash 具有 fallback 機制，當內部狀態為空時自動從當前路由取得
 *
 * 使用方式：
 * - 元件中：this.$storeManager.storeId
 * - JS 檔案中：import storeManager from '@/utils/storeManager'
 */

const state = Vue.observable({
	storeId: null,
	storeName: '',
	qrCodeHash: null,
})

class StoreManager {
	constructor() {
		this._state = state
	}

	updateFromRoute(qrCodeHash, storeInfo = {}) {
		if (!qrCodeHash) {
			this.reset()
			return
		}

		this._state.qrCodeHash = qrCodeHash
		this.syncStoreInfo(qrCodeHash, storeInfo)
	}

	syncStoreInfo(qrCodeHash, storeInfo = {}) {
		if (!qrCodeHash) {
			this.reset()
			return
		}

		const store = storeInfo?.[qrCodeHash]
		this._state.storeId = store?.storeId || null
		this._state.storeName = store?.storeName || ''
		this._state.qrCodeHash = qrCodeHash
	}

	reset() {
		this._state.storeId = null
		this._state.storeName = ''
		this._state.qrCodeHash = null
	}

	get storeId() {
		return this._state.storeId
	}

	get storeName() {
		return this._state.storeName
	}

	get qrCodeHash() {
		return this._state.qrCodeHash || router.currentRoute.params.random
	}
}

export default new StoreManager()
